<template>
    <div class="antialiased">
        <Sidebar />
        <div class="page">
            <Header :disabledSearch="true" ></Header>
            <div class="content">
                <div class="container">
                    <div class="page-header">
                        <div class="row d-flex justify-content-between">
                            <div class="col-auto">
                                <h2 class="page-title">
                                Konversi Pajak Coretax
                                </h2>
                            </div>
                            <div class="col-auto">
                                <div class="col-auto">
                                    <button class="btn btn-white" v-html="ic('filter')+' Filter'" @click="_showModal"> </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="alert alert-info">
                        <i class="fe fe-info mr-2"></i> Pilih filter untuk memuat data Konversi Pajak Coretax
                    </div>
                    <Skeleton
                        type="table"
                        :length="10"
                        class="mt-3 bg-white"
                        v-if="isLoading"
                    />
                    <Nodata v-if="!isLoading && data.length == 0" />
                    <div class="text-center my-6" v-if="!isLoading && data.length > 0">
                        <img :src="asset('doc.png')" alt="" style="width: 200px; opacity: .5">
                        <h3 class="my-3" v-html="data.length + ' Data'"></h3>
                        <button class="btn btn-primary" @click="_createExcel">Export Excel</button>
                    </div>
                </div>
            </div>
        </div>
        <FormFilter
            :config.sync="modal.config"
            :initData="modal.data" :dismiss.sync="modal.dismiss"
            :isSubmit.sync="modal.isSubmit"
            @submit="modal.action"
        />  
    </div>
</template>
<script>
import * as XLSX from "xlsx";
import $axios from "@/api";
import helper from "@/assets/js/helper.js";
import FormFilter from "./modals/filter-faktur-keluaran.vue";


export default {
    name: "FakturKeluaran",
    components: { FormFilter },

    data() {
        return {
            modal: {
                config: { view: false, title: null },
                data: null, isSubmit: false,
                action: () => {},
            },
            isLoading: false,   
            data: [],
            npwp_perusahaan: ''
        }
    },
    mixins: [helper],
    methods: {
        _get(filters){
            this.isLoading = true;
            $axios.get('external_app/coretax/faktur-keluaran', { params: filters}).then(res => {
                this.data = res.data.data;
                this.npwp_perusahaan = res.data.npwp_perusahaan;
            }).catch(err => {
                this.onError(err);
            }).finally(() => {
                this.isLoading = false;
            });
        },

        _showModal(){
            this.modal.config = {view: true, title: 'Filter'}
            this.modal.action = (filters) => {
                this.data = [];
                this._get(filters)
            }
        },

        _createExcel(){
            const fakturs = this.data;

            const headerFaktur = [
                ["NPWP Penjual","",this.npwp_perusahaan],
                ["","",""],
                ['Baris','Tanggal Faktur','Jenis Faktur','Kode Transaksi','Keterangan Tambahan','Dokumen Pendukung','Referensi','Cap Fasilitas','ID TKU Penjual','NPWP/NIK Pembeli','Jenis ID Pembeli','Negara Pembeli','Nomor Dokumen Pembeli','Nama Pembeli','Alamat Pembeli','Email Pembeli','ID TKU Pembeli',]
            ]

            const headerDetailFaktur = [[
                'Baris',
                'Barang/Jasa',
                'Kode Barang Jasa',
                'Nama Barang/Jasa',
                'Nama Satuan Ukur',
                'Harga Satuan',
                'Jumlah Barang Jasa',
                'Total Diskon',
                'DPP',
                'DPP Nilai Lain',
                'Tarif PPN',
                'PPN',
                'Tarif PPnBM',
                'PPnBM',
            ]];

            let dataFaktur = [];
            let dataDetailFaktur = [];
            for (let i = 0; i < fakturs.length; i++) {
                const baris = i + 1;
                const faktur = fakturs[i]; 
                const detailFakturs = faktur.detail_faktur;

                dataFaktur.push([
                    baris, //Baris
                    new Date(faktur.tanggal_faktur),//Tanggal Faktur
                    'Normal', //Jenis Faktur
                    '04', //Kode Transaksi
                    '', //Keterangan Tambahan
                    '', //Dokumen Pendukung
                    faktur.refrensi, //Referensi
                    '', //Cap Fasilitas
                    faktur.id_tku_penjual, //ID TKU Penjual
                    faktur.npwp_pembeli, //NPWP/NIK Pembeli
                    faktur.jenis_id_pembeli, //Jenis ID Pembeli
                    faktur.negara_pembeli, //Negara Pembeli
                    faktur.nomor_dokumen_pembeli, //Nomor Dokumen Pembeli
                    faktur.nama_pembeli, //Nama Pembeli
                    faktur.alamat_pembeli, //Alamat Pembeli
                    '', //Email Pembeli no mandatory
                    faktur.id_tku_pembeli, //ID TKU Pembeli
                ]); 

                
                for (let j = 0; j < detailFakturs.length; j++) {
                    const detailFaktur = detailFakturs[j];
                    dataDetailFaktur.push([
                        baris, //Baris
                        detailFaktur.barang, //Barang/Jasa
                        detailFaktur.code_barang_jasa, //Kode Barang Jasa
                        detailFaktur.nama_barang, //Nama Barang/Jasa
                        detailFaktur.nama_satuan_ukur, //Nama Satuan Ukur
                        detailFaktur.harga_satuan.toFixed(2), //Harga Satuan
                        detailFaktur.jumlah_barang, //Jumlah Barang Jasa
                        detailFaktur.total_diskon.toFixed(2), //Total Diskon
                        detailFaktur.dpp.toFixed(2), //DPP
                        detailFaktur.dpp_nilai_lain.toFixed(2), //DPP Nilai Lain
                        detailFaktur.tarif_ppn, //Tarif PPN
                        detailFaktur.ppn.toFixed(2), //PPN
                        0, //Tarif PPnBM
                        0, //PPnBM
                    ])   
                }
            }

            const fakturData = [...headerFaktur, ...dataFaktur];
            const detailFakturData = [...headerDetailFaktur, ...dataDetailFaktur];

            // Konversi ke Sheet
            const fakturSheet = XLSX.utils.aoa_to_sheet(fakturData);
            const detailFakturSheet = XLSX.utils.aoa_to_sheet(detailFakturData);

            // Merge A1:B1 for a header
            fakturSheet["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 1 } }];

            // Atur format untuk kolom tanggal (misal, kolom C = "C2", "C3", dst.)
            const range = XLSX.utils.decode_range(fakturSheet["!ref"]);
            for (let row = range.s.r + 1; row <= range.e.r; row++) {
                const cellAddress = XLSX.utils.encode_cell({ r: row, b: 3 }); // Kolom ke-3 (C)
                if (fakturSheet[cellAddress]) {
                    fakturSheet[cellAddress].t = "n"; // Set sebagai number (Excel date)
                    fakturSheet[cellAddress].z = "dd/mm/yyyy"; // Atur format tanggal
                }
            }
            // Workbook Baru
            const workbook = XLSX.utils.book_new();

            // Tambahkan Sheet ke Workbook
            XLSX.utils.book_append_sheet(workbook, fakturSheet, "Faktur");
            XLSX.utils.book_append_sheet(workbook, detailFakturSheet, "DetailFaktur");


            // Simpan ke File Excel
            XLSX.writeFile(workbook, "faktur-keluaran-yespajak.xlsx");
        }
    }

}
</script>